//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import parseTextMixin from '~/mixins/parseTextMixin'

export default {
  mixins: [parseTextMixin],
  props: {
    heroFeatures: { type: Array, default: () => ([]) },
    skuPrefix: { type: String, required: true },
    productName: { type: String, required: true },
    leMode: { type: Boolean, required: true },
    lePartMode: { type: Boolean, required: true },
    lePart: { type: Object, required: true },
    sku: { type: String, required: true }
  },
  data () {
    return {
      activeFeature: 0,
      leHeroFeatures: {
        'classics3-le_mattjones': {
          featureId: 'le-mattjones',
          image: 'hero-features/hero-classics3-le_mattjones.jpg',
          imageOffset: '50% 50%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'MATT JONES SIGNATURE SERIES CLASSICS³',
          description: 'Signature Series Classics³ designed by Pro Freestyle MTB rider Matt Jones. One of the biggest names in MTB, Matt Jones is a progressive all-round rider competing at the highest level in freestyle competitions around the world. The geology of the landscape Matt rides has inspired his Signature Series design.Featuring 4KO<sup>®</sup> Polarised Smoke Lenses with a signature engraving, and exclusive Lava arms with Brushed Black Icons. Accompanied by a Matt Jones Signature Series Microfibre.'
        },
        'classics3-le_airton': {
          featureId: 'le-airton',
          image: 'hero-features/hero-classics3-le_airton.jpg',
          imageOffset: '50% 50%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'AIRTON COZZOLINO SIGNATURE SERIES CLASSICS³',
          description: 'Introducing our latest Signature Series Classics³, designed by Pro Kitesurfer and 4x World Champion Airton Cozzzolino. A highly innovative and progressive rider, Airton has designed his first SunGod Signature Series to reflect his unique personality. Featuring Matte Blue Tortoise frames and 4KO® Polarised Smoke lenses with a signature engraving. Finished with Brushed Pink icons and accompanied by an Airton Cozzolino Signature Series microfibre.'
        },
        'renegades-le_woodsy': {
          featureId: 'le-woodsy',
          image: 'hero-features/hero-renegades-le_woodsy.jpeg',
          imageOffset: '50% 25%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'WOODSY SIGNATURE SERIES RENEGADES™',
          description: 'A unique design developed by a unique rider. Known for his effortless enthusiasm and progressive style, British Freeskier James \'Woodsy\' Woods competes at the top of his game, taking the title of Slopestyle World Champion in 2019. With a further X Games Gold medal and two Winter Olympics to his name, Woodsy has provided his on-the-ground expertise to develop his Signature Series Renegades™. Featuring Polarised 4KO<sup>®</sup> Smoke lenses with a signature engraving, an exclusive Black frame with Wood effect arms and Brushed Black icons. Accompanied by a Woodsy Signature Series Microfibre.'
        },
        'vanguards-le_woodsy': {
          featureId: 'le-woodsy-vanguards',
          image: 'hero-features/hero-vanguards-le_woodsy.jpg',
          imageOffset: '50% 50%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'WOODSY SIGNATURE SERIES VANGUARDS™',
          description: 'A unique design developed by a unique rider. Known for his effortless enthusiasm and progressive style, British Freeskier James \'Woodsy\' Woods competes at the top of his game, taking the title of Slopestyle World Champion in 2019. With a further X Games Gold medal and two Winter Olympics to his name, Woodsy has provided his on-the-ground expertise to develop his Signature Series Vanguards™ goggles. Featuring a 4KO<sup>®</sup>snow Smoke lens with Signature engraving, an exclusive Black frame with wood effect detailing, and a Black strap with a unique Woodsy Signature Series patch. Accompanied by a Woodsy Signature Series Microfibre.'
        },
        'vanguards-le_fwt20': {
          featureId: 'le-fwt20',
          image: 'hero-features/hero-vanguards-le_fwt20.jpg',
          imageOffset: '50% 50%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'FWT 2020 VANGUARDS™',
          description: 'A goggle that will go with you to the extreme. As the Official Eyewear Partner of the Freeride World Tour 2020, we\'ve designed a pair of Limited Edition FWT20 Vanguards™. 45° faces, backflips off 15 metre cliffs and countless no fall zones - it doesn\'t get much more extreme than this. The Freeride World Tour takes the best freeriders to 5 gnarly mountain faces across 3 continents to ride it out for the prestigious title of World Freeride Champion. Featuring a 4KO<sup>®</sup>snow Smoke lens with FWT engraving, an Exclusive Black/Red strap with Freeride World Tour logo and a FWT microfibre pouch.'
        },
        'sierras-le_hannahwhiteley': {
          featureId: 'le-hannahwhiteley',
          image: 'hero-features/hero-sierras-le_hannahwhiteley.jpg',
          imageOffset: '50% 0%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'HANNAH WHITELY SIGNATURE SERIES SIERRAS™',
          description: 'Limited Edition Sierras™ designed by SunGod Pro Team Kitesurfer and World Champion, Hannah Whiteley. Hannah is one of the most well-rounded athletes in kiting, with global success in both racing and freestyle disciplines. In 2017, Hannah took the title of Kite Speed World Champion and in 2018 she became the Vice Kiteboarding World Champion in the GKA Kiteboarding World Tour \'Air Games\'. Featuring Polarised 4KO<sup>®</sup> Smoke lenses with a Signature engraving, and exclusive Marble effect frames with Brushed Silver icons. Accompanied by a Hannah Whiteley Signature Series Marble effect microfibre pouch.'
        },
        'renegades-le_rfu': {
          featureId: 'le-rfu',
          image: 'hero-features/hero-renegades-le_rfu.jpg',
          imageOffset: '50% 50%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'HERITAGE GOLD ROSE RFU 150 RENEGADES™',
          description: 'Unrivaled durability, unrelenting performance. To celebrate the 150th Anniversary of England Rugby, we\'ve teamed up with RFU to create a Limited Edition pair of Heritage Gold Rose RFU 150 Renegades™. The SunGod reputation is built on our relentless obsession to create eyewear with performance and durability at it\'s core. For 150 years, these values have also been upheld by every England player that has set foot on the rugby pitch. Featuring Limited Edition Polarised 4KO<sup>®</sup> Gold lenses, with a Heritage Gold Rose laser lens engraving. Accompanied by Limited Edition RFU 150 Anniversary Heritage Rose packaging and microfibre.'
        },
        sns_fwt21: {
          featureId: 'le-fwt21',
          image: 'hero-features/hero-sns_fwt21.jpg',
          imageOffset: '50% 50%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'FWT 20/21 Limited Edition Snipers™',
          description: 'As the Official Eyewear Partner of the Freeride World Tour for the fourth year running, we\'ve designed a pair of  Limited Edition FWT21 Snipers™. The Freeride World Tour takes the world’s best freeride skiers and snowboarders to ride it out on some of the gnarliest terrain on the planet, for the coveted title of Freeride World Champion. These unique Snipers™ feature an exclusive FWT21 strap and are accompanied by a FWT21 microfibre pouch.'
        },
        vs_fwt21: {
          featureId: 'le-fwt21',
          image: 'hero-features/hero-vs_fwt21.jpg',
          imageOffset: '50% 50%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'FWT 20/21 Limited Edition Vanguards™',
          description: 'As the Official Eyewear Partner of the Freeride World Tour for the fourth year running, we\'ve designed a pair of  Limited Edition FWT21 Vanguards™. The Freeride World Tour takes the world’s best freeride skiers and snowboarders to ride it out on some of the gnarliest terrain on the planet, for the coveted title of Freeride World Champion. These unique Vanguards™ feature an exclusive FWT21 strap and are accompanied by a FWT21 microfibre pouch.'
        },
        sns_pow21: {
          featureId: 'le-pow21',
          image: 'hero-features/hero-sns_pow21.jpg',
          imageOffset: '50% 50%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'POW UK Goggle Strap',
          description: 'Powder days are the best days of our lives. To protect our powder days for winters to come, we\'ve teamed up with Protect our Winters UK for the 3rd year running to create a Limited Edition POW UK Goggle Strap. POW UK inspire and equip individual, brands, athletes and ski resorts to taker positive action and address the climate crisis. This Limited Edition Goggle Strap features the distinctive POW UK logo and is detailed with contours of the Swiss Alps, the home of our best powder days.'
        },
        vs_pow21: {
          featureId: 'le-pow21',
          image: 'hero-features/hero-vs_pow21.jpg',
          imageOffset: '50% 50%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'POW UK Goggle Strap',
          description: 'Powder days are the best days of our lives. To protect our powder days for winters to come, we\'ve teamed up with Protect our Winters UK for the 3rd year running to create a Limited Edition POW UK Goggle Strap. POW UK inspire and equip individual, brands, athletes and ski resorts to taker positive action and address the climate crisis. This Limited Edition Goggle Strap features the distinctive POW UK logo and is detailed with contours of the Swiss Alps, the home of our best powder days.'
        },
        sns_billymorgan: {
          featureId: 'le-billymorgan',
          image: 'hero-features/hero-sns_billymorgan.jpg',
          imageOffset: '50% 50%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'BILLY MORGAN SIGNATURE SERIES',
          description: 'Taking inspiration from his headline moment, landing the world\'s first backside 1800 quad cork, Olympic and X Games medallist Billy Morgan has designed a unique Signature Series Goggle strap. This Limited Edition strap features Billy\'s signature alongside a distinctive corkscrew that reflects his iconic snowboarding career. Billy\'s Signature Series goggle strap is available with both Snipers™ or Vanguards™ and is accompanied by a unique Billy Morgan microfibre pouch.'
        },
        vs_billymorgan: {
          featureId: 'le-billymorgan',
          image: 'hero-features/hero-vs_billymorgan.jpg',
          imageOffset: '50% 50%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'BILLY MORGAN SIGNATURE SERIES',
          description: 'Taking inspiration from his headline moment, landing the world\'s first backside 1800 quad cork, Olympic and X Games medallist Billy Morgan has designed a unique Signature Series Goggle strap. This Limited Edition strap features Billy\'s signature alongside a distinctive corkscrew that reflects his iconic snowboarding career. Billy\'s Signature Series goggle strap is available with both Snipers™ or Vanguards™ and is accompanied by a unique Billy Morgan microfibre pouch.'
        },
        'velans-le_canyon': {
          featureId: 'velans-le_canyon',
          image: 'hero-features/hero-velans-le_canyon.jpg',
          imageOffset: '30% 30%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'CANYON DHB SUNGOD VELANS™',
          description: 'Canyon dhb SunGod are the UK\'s top UCI Continental cycling team. The team have been a dominant force across the UK and European racing scene, with multiple riders representing GB at both Olympic and Commonwealth Games. To celebrate becoming a title sponsor, we asked the team to design a pair of Limited-Edition Velans™, worn by the riders as they compete on the world stage and available to you. Featuring an 8KO® Gold lens with a unique team logo laser-engraving, paired with a navy top frame and white bottom frame to match the team’s racing colours. Accompanied by a Limited Edition Canyon DHB SunGod microfibre, made from 100% recycled plastic bottles.'
        },
        'renegades-le_mclaren': {
          featureId: 'renegades-le_mclaren',
          image: 'hero-features/hero-mclaren.jpg',
          imageOffset: '70% 30%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'M~~c~~LAREN F1 TEAM RENEGADES™',
          description: 'Together with the McLaren F1 Team we share one focus: to deliver excellence. Two British brands. Led by innovation. Defined by design. Underpinned by community. Brought together in an effortless partnership founded on the fearless pursuit of better. Built with SunGod’s 8KO® lens technology and ultralightweight, durable frames, fused with McLaren’s signature Papaya colourway and accented with the iconic McLaren logo and speedmark.'
        },
        'renegades-le_mclarenplus': {
          featureId: 'renegades-le_mclarenplus',
          image: 'hero-features/hero-mclaren.jpg',
          imageOffset: '70% 30%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'M~~c~~LAREN F1 TEAM RENEGADES™',
          description: 'Together with the McLaren F1 Team we share one focus: to deliver excellence. Two British brands. Led by innovation. Defined by design. Underpinned by community. Brought together in an effortless partnership founded on the fearless pursuit of better. Built with SunGod’s 8KO® lens technology and ultralightweight, durable frames, fused with McLaren’s signature Papaya colourway and accented with the iconic McLaren logo and speedmark.'
        },
        'sierras-le_mclaren': {
          featureId: 'sierras-le_mclaren',
          image: 'hero-features/hero-mclaren.jpg',
          imageOffset: '70% 30%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'M~~c~~LAREN F1 TEAM SIERRAS™',
          description: 'Together with the McLaren F1 Team we share one focus: to deliver excellence. Two British brands. Led by innovation. Defined by design. Underpinned by community. Brought together in an effortless partnership founded on the fearless pursuit of better. Built with SunGod’s 8KO® lens technology and ultralightweight, durable frames, fused with McLaren’s signature Papaya colourway and accented with the iconic McLaren logo and speedmark.'
        },
        'sierras-le_mclarenplus': {
          featureId: 'sierras-le_mclarenplus',
          image: 'hero-features/hero-mclaren.jpg',
          imageOffset: '70% 30%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'M~~c~~LAREN F1 TEAM SIERRAS™',
          description: 'Together with the McLaren F1 Team we share one focus: to deliver excellence. Two British brands. Led by innovation. Defined by design. Underpinned by community. Brought together in an effortless partnership founded on the fearless pursuit of better. Built with SunGod’s 8KO® lens technology and ultralightweight, durable frames, fused with McLaren’s signature Papaya colourway and accented with the iconic McLaren logo and speedmark.'
        },
        'sierras-le_ln4': {
          featureId: 'sierras-le_ln4',
          image: 'hero-features/hero-ln4.jpg',
          imageOffset: '70% 30%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'LANDO LN4 SIERRAS™',
          description: 'Together with the McLaren F1 Team, we share one focus: to deliver excellence. Two British brands. Led by innovation. Defined by design. Underpinned by community. Brought together in an effortless partnership founded on the fearless pursuit of better. Introducing our Limited Edition Lando LN4 Sierras™️, inspired by Formula 1 driver Lando Norris. Built with our market-leading 8KO®️ lens technology and ultralightweight, durable frames. This is the Future in Focus.'
        },
        'classics3-le_dr3': {
          featureId: 'classics3-le_dr3',
          image: 'hero-features/hero-dr3.jpg',
          imageOffset: '70% 30%',
          label: 'Limited Edition',
          details_label: 'Limited Edition',
          title: 'DANIEL DR3 CLASSICS³',
          description: 'Together with the McLaren F1 Team, we share one focus: to deliver excellence. Two British brands. Led by innovation. Defined by design. Underpinned by community. Brought together in an effortless partnership founded on the fearless pursuit of better. Introducing our Limited Edition Daniel DR3 Classics³, inspired by Formula 1 driver Daniel Ricciardo. Built with our market-leading 8KO®️ lens technology and ultralightweight, durable frames. This is the Future in Focus.'
        }
      }
    }
  },
  computed: {
    lePartSku () {
      return this.lePart.lePart || null
    },
    lensTech () {
      return this.$store.getters['product/lensTech'](this.sku)
    },
    visibleHeroFeatures () {
      let heroFeatures = this.heroFeatures.filter(feature => !this.lensTech || (this.lensTech || '').match(feature.lensTechFilter || '.*')).map(feature => ({
        ...feature,
        featureId: feature.id,
        image: feature.image.url,
        imageOffset: `${feature.image.focalPoint.x * 100}% ${feature.image.focalPoint.y * 100}%`
      }))

      if (this.leMode && this.sku in this.leHeroFeatures) heroFeatures = [this.leHeroFeatures[this.sku], ...heroFeatures]
      if (this.lePartMode && this.lePartSku in this.leHeroFeatures) heroFeatures = [this.leHeroFeatures[this.lePartSku], ...heroFeatures]

      return heroFeatures.slice(0, 3)
    }
  },
  watch: {
    activeFeature (idx) {
      const feature = (this.heroFeatures[idx] || {}).featureId
      this.$store.dispatch('session/TRACK', { event: 'PP_FEATURES_CLICK', sku: this.sku, body: feature })
    }
  },
  methods: {
    goTo (slide) {
      this.activeFeature = slide
    }
  }
}
